import React from 'react';
import Card from 'react-bootstrap/Card';

const SUPPORT_EMAIL = 'bjpineconego@gmail.com';

const Privacy = () => {
  return (
    <div>
      <Card>
        <div className='padding2em'>
          <Card.Title>
            <h3>隐私政策</h3>
          </Card.Title>
          <Card.Text>
            <div className='vPrivacy-content'>
              <p className='vPrivacy-intro'>
                欢迎使用松果网与松果Go。您在使用我们的服务时，我们可能会收集和使用您的相关信息。
                为了保障您的权益，让您能安心地使用本网站和
                App，特此向您说明我们的隐私保护政策。 最后更新日期：2026 年 9 月
                14 日。
              </p>
              <div className='vPrivacy-desc'>
                <dl>
                  <dt>引言</dt>
                  <dd>
                    松果网（Pinecone Go，运营方：Bluejay
                    Inc）是服务于海外华人的跨境集运转运平台。
                    我们尊重并保护您的隐私。您使用我们的服务，即意味着同意我们按照本《隐私政策》收集和使用您的相关信息。
                  </dd>
                </dl>
                <dl>
                  <dt>适用范围</dt>
                  <dd>
                    本政策适用于松果网网站（pineconego.com）以及松果Go
                    移动应用（Android 版应用 ID：com.pineconegomobile）。
                    本政策不适用于本网站与 App
                    以外的第三方网站或服务，也不适用于非本平台委托或参与管理的人员。
                  </dd>
                </dl>
                <dl>
                  <dt>App 收集的信息</dt>
                  <dd>
                    松果Go App
                    会收集以下信息，用于提供服务、管理您的账号并向您发送订单通知：
                    <br />· <strong>账号信息</strong>
                    ：姓名、电子邮箱、账号标识（用户
                    ID）。使用邮箱注册时需验证电子邮箱；
                    使用微信登录时，微信平台会向我们提供您的微信昵称，用作您在松果Go
                    中的显示名称，我们不会获取您的微信密码。
                    <br />· <strong>联系与寄递信息</strong>
                    ：电话号码，以及您填写的寄件人与收件人姓名、电话和详细地址。
                    <br />· <strong>交易记录</strong>
                    ：您的运单与订单记录，包括服务类型、包裹信息和费用金额。
                    <br />· <strong>设备推送标识符</strong>
                    ：用于向您推送包裹状态提醒。您可以在系统设置中关闭通知权限。
                    <br />
                    松果Go App <strong>不会</strong>
                    收集您的地理位置、通讯录、照片、日历、健康数据，也不含广告
                    SDK， 不使用广告标识符（Advertising ID）。
                  </dd>
                </dl>
                <dl>
                  <dt>关于支付</dt>
                  <dd>
                    App 内的支付由第三方支付服务商 Stripe
                    处理。您的银行卡号、CVV 等支付凭证直接提交给 Stripe，
                    松果网不会接触、也不会存储这些信息。我们仅保留交易金额、时间与订单状态等交易记录。
                    Stripe 对其收集的信息适用其自身的隐私政策。
                  </dd>
                </dl>
                <dl>
                  <dt>信息的使用</dt>
                  <dd>
                    我们收集的信息仅用于以下用途：1.
                    提供并完成跨境集运与转运服务； 2.
                    创建、验证和管理您的账号；3.
                    向您发送与订单和服务相关的通知； 4.
                    验证用户所提交信息的真实性，防范欺诈行为。
                  </dd>
                </dl>
                <dl>
                  <dt>信息的分享</dt>
                  <dd>
                    我们不会出售您的个人信息，也不会为第三方的独立商业用途分享您的个人信息。
                    仅在以下必要情形下会发生信息传递：为完成运输与清关，必需的收寄件人姓名、电话、地址会提供给承运方、
                    报关行及海关等主管机关；为完成支付，交易信息会传递给
                    Stripe；
                    以及为遵守适用法律、法规或有权机关的要求而必须披露的情形。
                    受托为我们提供技术与基础设施服务的供应商（如云服务商）仅能在为我们提供服务的范围内处理数据。
                  </dd>
                </dl>
                <dl>
                  <dt>信息的安全</dt>
                  <dd>
                    App 与网站同服务器之间的数据传输均使用 HTTPS/TLS 加密连接。
                    我们的服务器设有防火墙及访问控制措施，努力保护您的信息不被未经授权的访问、使用或泄漏。
                  </dd>
                </dl>
                <dl>
                  <dt>信息的保留与删除</dt>
                  <dd>
                    您可以随时在 App 内（我的 → 账号设置 →
                    删除账号）或通过邮件申请删除账号， 详细步骤请见{' '}
                    <a href='/delete-account'>删除账号</a> 页面。
                    账号信息、地址簿、推送标识符和使用日志将在处理完成后 30
                    天内从生产系统中移除，90 天内从备份中清除；
                    已完成的运单与交易记录因税务、财务及海关合规要求自交易完成起保留
                    5 年，期满后删除或永久匿名化。
                  </dd>
                </dl>
                <dl>
                  <dt>网站的 Cookie 与分析</dt>
                  <dd>
                    松果网网站使用 Cookie 与第三方分析工具（Google
                    Analytics）记录访问页面、浏览器类型等信息，
                    用于了解网站使用情况并改进服务。这些分析工具仅用于网站，松果Go
                    App 不含任何分析或广告 SDK。 网站与 App
                    均支持微信登录，登录时微信平台向我们提供的信息见上文「App
                    收集的信息」一节。
                  </dd>
                </dl>
                <dl>
                  <dt>未成年人信息保护</dt>
                  <dd>
                    松果网的服务面向年满 18
                    周岁的用户。我们非常重视对未成年人信息的保护，
                    不会有意收集未成年人的个人信息。若您是 18
                    周岁以下的未成年人，请在使用前事先取得您的家长或法定监护人的同意。
                  </dd>
                </dl>
                <dl>
                  <dt>本政策的修订</dt>
                  <dd>
                    本隐私政策可能会不时修订，修订后的条款将及时发布到本页面，并更新页首的最后更新日期。
                  </dd>
                </dl>
                <dl>
                  <dt>联系我们</dt>
                  <dd>
                    对本政策有任何疑问，或需要行使您的数据权利，请联系{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>。
                  </dd>
                </dl>
              </div>
            </div>
          </Card.Text>
        </div>
      </Card>
    </div>
  );
};

export default Privacy;
